import styled from 'styled-components';

const Action = styled.div`
  flex: 1;
`;

export default Action;
